import { TabBar } from "antd-mobile";
import { useAuth, useTranslateContext } from "fennec-ui";
import Icofont from "react-icofont";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes, useMatch, useNavigate } from "react-router";
import { access, level } from "../../../../common/Tool";
import MenuLevelTwo, { notifyForHeader, statusForHeader } from "../../../components/MenuLevelTwo";
import Events from "./Events";
import Infrastructure from "./Infrastructure";
import Main from "./Main";
import Notify from "./Notify";

const menu = (status, notify) => {
    const x = [
        {
            uuid: "main",
            name: "Главная",
            component: (props) => (<Main {...props} />),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ],
            icon: function () {
                return (<Icofont icon="home" style={{ fontSize: "22px" }} />)
            },
            iconselected: function () {
                return (<Icofont icon="home" style={{ fontSize: "22px", color: "#001529" }} />)
            },
        },
        {
            uuid: "events",
            default: true,
            name: "Мероприятия",
            component: (props) => (<Events {...props} />),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ],
            icon: function () {
                return (<Icofont icon="ui-calendar" style={{ fontSize: "22px" }} />)
            },
            iconselected: function () {
                return (<Icofont icon="ui-calendar" style={{ fontSize: "22px", color: "#001529" }} />)
            },
        },
        {
            uuid: "notify",
            name: "Уведомления",
            component: (props) => (<Notify {...props} />),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ],

            icon: function () {
                return (<Icofont icon="notification" style={{ fontSize: "22px" }} />)
            },
            iconselected: function () {
                return (<Icofont icon="notification" style={{ fontSize: "22px", color: "#001529" }} />)
            },
            badge: (element) => {
                var noty = notifyForHeader(notify);
                var stat = statusForHeader(status);
                return {
                    count: noty.length + stat.length
                }
            }
        },
        {
            uuid: "infrastructure",
            name: "Инфраструктура",
            component: (props) => (<Infrastructure {...props} />),
            role: [
                { "ID": 4, "nazvanie": "ОбычныйПользователь" },
            ],
            icon: function () {
                return (<Icofont icon="instrument" style={{ fontSize: "22px" }} />)
            },
            iconselected: function () {
                return (<Icofont icon="instrument" style={{ fontSize: "22px", color: "#001529" }} />)
            },
        }
    ]
    return x
};
// function Breadcrumbs() {
//     let matches = useMatches();
//     let crumbs = matches
//         // first get rid of any matches that don't have handle and crumb
//         .filter((match) => Boolean(match.handle?.crumb))
//         // now map them into an array of elements, passing the loader
//         // data to each one
//         .map((match) => match.handle.crumb(match.data));
//     return (
//         <ol>
//             {crumbs.map((crumb, index) => (
//                 <li key={index}>{crumb}</li>
//             ))}
//         </ol>
//     );
// }
export default function Common(props) {
    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status);
    const notify = useSelector(state => state.home.notify);
    const t = useTranslateContext();

    return (<div className="subcontent">
        <div className={"content"}>
            <Routes>
                {menu(status, notify).map((e, idx) => {
                    if (e.default && access(e, role_by_id)) {
                        return <Route key={"index-" + e.uuid} index element={<Navigate replace to={e.uuid} />} />
                    }
                })}
                {menu(status, notify).map((e, idx) => {
                    if (e.component && access(e, role_by_id)) {
                        return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={e.component({
												level: {
													parent: props?.level,
													uuid: e?.uuid,
													name: e?.name,
													color: e?.color,
													role: e?.role,
                                                    hidden: e.hidden
												},
											 })} />
                    }
                })}
            </Routes>
        </div>
        <div className={"footer"}>
            <MenuLevelTwo menu={menu(status, notify)} />
        </div>
    </div>)
}

